import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchSummaryComponent } from './search-summary.component';

@NgModule({
  declarations: [SearchSummaryComponent],
  imports: [CommonModule],
  exports: [SearchSummaryComponent],
})
export class SearchSummaryModule {}
